import {
  getBuildingsByZipCode,
  nonMemberSignupUser,
  nonMemberSignupUserWithoutPackage,
  clearNonMemberData,
} from "../../../Redux/Auth/AuthActions";
import AdditionalAmenitiesModal from "../../../Components/User/AdditionalAmenitiesModal/AdditionalAmenitiesModal";
import AdditionalAddonsModal from "../../../Components/User/AdditionalAddonsModal/AdditionalAddonsModal";
import { ColDef, GetRowIdParams, ICellRendererParams } from "ag-grid-community";
import MobileHeader from "../../../Components/User/MobileHeader/MobileHeader";
import { ReactComponent as TickIcon } from "../../../Assets/Tick.svg";
import { FaFilePdf, FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Stepper from "../../../Components/Common/Stepper/Stepper";
import Loading from "../../../Components/Common/Loading/Loading";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { AppDispatch, RootState } from "../../../Redux/store";
import Header from "../../../Components/User/Header/Header";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import generateUuid from "../../../Util/generateUuid";
import SignatureCanvas from "react-signature-canvas";
import toastHelper from "../../../Util/toastHelper";
import styles from "./NonMemberSignup.module.scss";
import Select, { components } from "react-select";
import validator from "../../../Util/validator";
import { HiDotsVertical } from "react-icons/hi";
import { Switch } from "react-animated-switch";
import { AgGridReact } from "ag-grid-react";
import { CiSearch } from "react-icons/ci";
import API from "../../../API/API";
import html2pdf from "html2pdf.js";
import axios from "axios";

type AddonSelection = {
  addonId: number;
  noofAddonUnits: number;
  notifyAddon: boolean;
};

type ParkingSelection = {
  parkingId: string;
  noOfVehicle: number;
  notifyParking: boolean;
};

interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  bookingAllowed: boolean;
}

const Step1 = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
  phoneNumber,
  setPhoneNumber,
  email,
  setEmail,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  errors,
}: {
  firstName: string;
  setFirstName: React.Dispatch<React.SetStateAction<string>>;
  lastName: string;
  setLastName: React.Dispatch<React.SetStateAction<string>>;
  phoneNumber: string;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  password: string;
  setPassword: React.Dispatch<React.SetStateAction<string>>;
  confirmPassword: string;
  setConfirmPassword: React.Dispatch<React.SetStateAction<string>>;
  showPassword: boolean;
  setShowPassword: React.Dispatch<React.SetStateAction<boolean>>;
  showConfirmPassword: boolean;
  setShowConfirmPassword: React.Dispatch<React.SetStateAction<boolean>>;
  errors: {
    email: string;
    password: string;
    confirmPassword: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
  };
}) => {
  return (
    <div className={styles.stepOneContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Personal Information</p>
      </div>
      <form className={styles.stepOneForm}>
        <>
          <div className={styles.inputContainer}>
            <p className={styles.label}>First Name</p>
            <input
              className={styles.input}
              type="text"
              value={firstName}
              autoComplete="firstName"
              onChange={(e) => setFirstName(e.target.value)}
            />
            <p className={styles.error}>{errors.firstName}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Last Name</p>
            <input
              className={styles.input}
              type="text"
              value={lastName}
              autoComplete="lastName"
              onChange={(e) => setLastName(e.target.value)}
            />
            <p className={styles.error}>{errors.lastName}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Phone Number</p>
            <input
              className={styles.input}
              type="text"
              value={phoneNumber}
              autoComplete="phoneNumber"
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(value)) {
                  setPhoneNumber(value);
                }
              }}
            />
            <p className={styles.error}>{errors.phoneNumber}</p>
          </div>
        </>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Email</p>
          <input
            className={styles.input}
            type="email"
            value={email}
            autoComplete="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <p className={styles.error}>{errors.email}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Password</p>
          <div className={styles.passwordInputContainer}>
            <input
              type={showPassword ? "text" : "password"}
              className={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.showPasswordButton}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? (
                <FaRegEyeSlash className={styles.icon} />
              ) : (
                <FaRegEye className={styles.icon} />
              )}
            </button>
          </div>
          <p className={styles.error}>{errors.password}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Confirm Password</p>
          <div className={styles.passwordInputContainer}>
            <input
              type={showConfirmPassword ? "text" : "password"}
              className={styles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              className={styles.showPasswordButton}
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? (
                <FaRegEyeSlash className={styles.icon} />
              ) : (
                <FaRegEye className={styles.icon} />
              )}
            </button>
          </div>
          <p className={styles.error}>{errors.confirmPassword}</p>
        </div>
      </form>
    </div>
  );
};

const CustomOption = (props: any) => {
  const { isSelected, isFocused } = props;
  return (
    <components.Option {...props}>
      <div
        className={
          isSelected
            ? styles.selectedOptionContainer
            : isFocused
              ? styles.focusedOptionContainer
              : styles.optionContainer
        }
      >
        <div className={styles.imageContainer}>
          <img src={props?.data?.building?.image} alt="buildingImage" />
        </div>
        <div className={styles.infoContainer}>
          <p className={styles.name}>{props?.data?.building?.name}</p>
          <p className={styles.address}>{props?.data?.building?.address}</p>
        </div>
      </div>
    </components.Option>
  );
};

const CustomSingleValue = (props: any) => {
  return (
    <components.SingleValue {...props}>
      <div className={styles.optionContainer}>
        <div className={styles.imageContainer}>
          <img src={props?.data?.building?.image} alt="buildingImage" />
        </div>
        <div className={styles.infoContainer}>
          <p className={styles.name}>{props?.data?.building?.name}</p>
          <p className={styles.address}>{props?.data?.building?.address}</p>
        </div>
      </div>
    </components.SingleValue>
  );
};

const Step2 = ({
  setAdditionalAmenitiesModal,
  selectedBuilding,
  setSelectedBuilding,
  zipCode,
  setZipCode,
  selectedPackage,
  setSelectedPackage,
  setAdditionalAddonsModal,
  errors,
}: {
  setAdditionalAmenitiesModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedBuilding: any;
  setSelectedBuilding: React.Dispatch<React.SetStateAction<any>>;
  zipCode: string;
  setZipCode: React.Dispatch<React.SetStateAction<string>>;
  selectedPackage: number;
  setSelectedPackage: React.Dispatch<React.SetStateAction<number>>;
  setAdditionalAddonsModal: React.Dispatch<React.SetStateAction<boolean>>;
  errors: {
    zipCode: string;
  };
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { getBuildingsByZipCodeLoading, getBuildingsByZipCodeData } =
    useSelector((state: RootState) => state.auth);

  const zipCodeSearchHandler = () => {
    const { isValid } = validator([
      {
        key: "zipCode",
        type: "text",
        value: zipCode,
      },
    ]);
    if (isValid) {
      if (!getBuildingsByZipCodeLoading) {
        setSelectedBuilding(null);
        setSelectedPackage(-1);
        dispatch(getBuildingsByZipCode({ zipCode }));
      }
    } else {
      toastHelper.error("Zip Code is required");
    }
  };

  return (
    <div className={styles.stepTwoContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Amenities Near You</p>
      </div>
      <div className={styles.inputBuildingContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Enter Zip Code</p>
          <div className={styles.searchContainer}>
            <input
              className={styles.input}
              type="text"
              value={zipCode}
              maxLength={5}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(value)) {
                  setZipCode(value);
                }
              }}
            />
            <div className={styles.iconContainer}>
              <CiSearch
                className={styles.icon}
                onClick={zipCodeSearchHandler}
              />
            </div>
          </div>
          <p className={styles.error}>{errors.zipCode}</p>
        </div>
        <div className={styles.buildingSelectContainer}>
          <p className={styles.label}>Select Building</p>
          <Select
            options={getBuildingsByZipCodeData || []}
            className={styles.select}
            components={{
              Option: CustomOption,
              SingleValue: CustomSingleValue,
            }}
            isMulti={false}
            value={selectedBuilding}
            onChange={(option: any) => {
              setSelectedBuilding(option);
              setSelectedPackage(-1);
            }}
            getOptionLabel={(option: any) => option?.building?.buildingName}
            getOptionValue={(option: any) =>
              option?.building?.buildingId.toString()
            }
            isSearchable={false}
          />
        </div>
        <p className={styles.error}>{errors.zipCode}</p>
      </div>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Select package</p>
      </div>

      {!selectedBuilding && (
        <div className={styles.headingContainer}>
          <p className={styles.label}>Please select a building</p>
        </div>
      )}

      <div className={styles.additionalbuttonInline}>
        {selectedBuilding?.building?.parking?.length > 0 && (
          <div className={styles.additionalbuttonContainer}>
            <button onClick={() => setAdditionalAmenitiesModal(true)}>
              Select Additional Amenities
            </button>
          </div>
        )}

        {selectedBuilding?.building?.addon?.length > 0 &&
          selectedPackage !== -1 && (
            <div className={styles.additionalbuttonContainer}>
              <button onClick={() => setAdditionalAddonsModal(true)}>
                Select Additional Addons
              </button>
            </div>
          )}
      </div>

      <div className={styles.packagesContainer}>
        {selectedBuilding?.packages?.map((pack: any, i: number) => {
          return (
            <div key={i} className={styles.package}>
              <div className={styles.infoContainer}>
                <p className={styles.name}>{pack?.packageName}</p>
                <div className={styles.priceContainer}>
                  {pack?.discountRate > 0 ? (
                    <>
                      <p className={styles.price}>
                        ${pack?.totalRates - pack?.discountRate}/mo
                      </p>
                      <p className={styles.cancelledPrice}>
                        ${pack?.totalRates}/mo
                      </p>
                    </>
                  ) : (
                    <p className={styles.price}>${pack?.totalRates}/mo</p>
                  )}
                </div>
              </div>
              {
                <div className={styles.trialContainer}>
                  {pack?.isFreeMonth && (
                    <p className={styles.label}>
                      This package has a limited time free trial
                    </p>
                  )}
                </div>
              }
              <div className={styles.buttonContainer}>
                <button
                  className={styles.button}
                  onClick={() => {
                    if (selectedPackage === pack?.packageId) {
                      setSelectedPackage(-1);
                    } else {
                      setSelectedPackage(pack?.packageId);
                    }
                  }}
                >
                  {selectedPackage === pack?.packageId ? "Selected" : "Select"}
                </button>
              </div>
              <div className={styles.featuresContainer}>
                <p>Plan includes</p>
                {pack?.packageAmenities?.map((amenity: any, j: number) => {
                  return (
                    <div key={j} className={styles.feature}>
                      <div className={styles.iconContainer}>
                        <TickIcon className={styles.icon} />
                      </div>
                      <p className={styles.label}>{amenity}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      {selectedBuilding?.packages?.length === 0 && (
        <div className={styles.noPackageContainer}>
          <p className={styles.text}>No package found</p>
        </div>
      )}
    </div>
  );
};

const Step5 = ({
  selectedBuilding,
  parkingSelections,
  addonSelections,
  email,
  voucherCode,
  setVoucherCode,
  voucherSuccess,
  setVoucherSuccess,
  cardHolderName,
  setCardHolderName,
  cardNumber,
  setCardNumber,
  expiry,
  setExpiry,
  cvv,
  setCvv,
  errors,
  packageData,
  setErrors,
}: {
  selectedBuilding: any;
  parkingSelections: ParkingSelection[];
  addonSelections: AddonSelection[];
  email: string;
  voucherCode: string;
  setVoucherCode: React.Dispatch<React.SetStateAction<string>>;
  voucherSuccess: any;
  setVoucherSuccess: React.Dispatch<React.SetStateAction<any>>;
  cardHolderName: string;
  setCardHolderName: React.Dispatch<React.SetStateAction<string>>;
  cardNumber: string;
  setCardNumber: React.Dispatch<React.SetStateAction<string>>;
  expiry: string;
  setExpiry: React.Dispatch<React.SetStateAction<string>>;
  cvv: string;
  setCvv: React.Dispatch<React.SetStateAction<string>>;
  errors: {
    cardHolderName: string;
    cardNumber: string;
    expiry: string;
    cvv: string;
    voucherCode: string;
  };
  setErrors: React.Dispatch<
    React.SetStateAction<{
      cardHolderName: string;
      cardNumber: string;
      expiry: string;
      cvv: string;
      voucherCode: string;
      firstName: string;
      lastName: string;
      phoneNumber: string;
      email: string;
      password: string;
      confirmPassword: string;
      zipCode: string;
    }>
  >;
  packageData: any;
}) => {
  const applyVoucherHandler = async () => {
    if (voucherCode.trim() !== "") {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "",
      }));
      try {
        const { data } = await axios({
          url: `${API.members.validateVoucher.url}?voucherCode=${voucherCode}&email=${email}&voucherType=1`,
          method: API.members.validateVoucher.method,
        });
        setVoucherSuccess(data);
      } catch (error: any) {
        if (error?.response?.data?.message) {
          setErrors((prev) => ({
            ...prev,
            voucherCode: error?.response?.data?.message ?? "",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            voucherCode: "Something went wrong",
          }));
        }
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        voucherCode: "Voucher code is required",
      }));
    }
  };

  const removeVoucherHandler = () => {
    setVoucherSuccess(null);
    setVoucherCode("");
  };

  const monthlySubtotalBeforeVoucher = useMemo(() => {
    const packageRate =
      packageData?.discountRate > 0
        ? Number(packageData?.totalRates ?? 0) -
          Number(packageData?.discountRate ?? 0)
        : Number(packageData?.totalRates ?? 0);

    const parkingTotal = parkingSelections.reduce((acc, selection) => {
      const parking = selectedBuilding?.building?.parking?.find(
        (p: any) => String(p.parkingId) === selection.parkingId,
      );

      return (
        acc + Number(parking?.cost ?? 0) * Number(selection.noOfVehicle ?? 0)
      );
    }, 0);

    const addonTotal = addonSelections.reduce((acc, selection) => {
      const addon = selectedBuilding?.building?.addon?.find(
        (a: any) => a.addonId === selection.addonId,
      );

      return (
        acc + Number(addon?.cost ?? 0) * Number(selection.noofAddonUnits ?? 0)
      );
    }, 0);

    return packageRate + parkingTotal + addonTotal;
  }, [packageData, parkingSelections, addonSelections, selectedBuilding]);

  const voucherDiscountAmount = useMemo(() => {
    if (!voucherSuccess?.success || !voucherSuccess?.voucher) return 0;

    const { percent, maxDiscount } = voucherSuccess.voucher;
    const percentValue = Number(percent ?? 0);

    let discount = (monthlySubtotalBeforeVoucher * percentValue) / 100;

    if (maxDiscount !== null && maxDiscount !== undefined) {
      discount = Math.min(discount, Number(maxDiscount));
    }

    return Number(discount.toFixed(2));
  }, [monthlySubtotalBeforeVoucher, voucherSuccess]);
  return (
    <div className={styles.stepFiveContainer}>
      <div className={styles.stepFiveContentWrapper}>
        <div className={styles.packageInfoWrapper}>
          {packageData !== null && packageData !== undefined && (
            <div className={styles.packageInfoContainer}>
              <p className={styles.label}>Package Selected</p>

              <p className={styles.packageName}>
                {packageData?.packageName} - ${packageData?.totalRates}/mo
              </p>
            </div>
          )}

          {parkingSelections.some((s) => s.noOfVehicle > 0) && (
            <div className={styles.additionalAmenitiesContainer}>
              <p className={styles.label}>Additional Amenities</p>

              <div className={styles.amenitiesList}>
                {parkingSelections.map((selection, i) => {
                  const parking = selectedBuilding?.building?.parking?.find(
                    (p: any) => String(p.parkingId) === selection.parkingId,
                  );

                  if (!parking || selection.noOfVehicle <= 0) return null;

                  return (
                    <div key={i} className={styles.amenity}>
                      <p className={styles.label}>
                        {parking?.amenityName} - Parking
                      </p>

                      <p className={styles.price}>
                        ${(parking?.cost ?? 0) * selection.noOfVehicle}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {addonSelections.some((s) => s.noofAddonUnits > 0) && (
            <div className={styles.additionalAmenitiesContainer}>
              <p className={styles.label}>Additional Addons</p>

              <div className={styles.amenitiesList}>
                {addonSelections.map((selection, i) => {
                  const addon = selectedBuilding?.building?.addon?.find(
                    (a: any) => a.addonId === selection.addonId,
                  );

                  if (!addon || selection.noofAddonUnits <= 0) return null;

                  return (
                    <div key={i} className={styles.amenity}>
                      <p className={styles.label}>
                        {addon?.amenityName} - Addon
                      </p>

                      <p className={styles.price}>
                        ${(addon?.cost ?? 0) * selection.noofAddonUnits}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          )}

          {!voucherSuccess ? (
            <div className={styles.couponInputContainer}>
              <div className={styles.couponInputBox}>
                <input
                  className={styles.input}
                  type="text"
                  placeholder="Enter Voucher Code"
                  value={voucherCode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\s/g, "");

                    setVoucherCode(value);
                  }}
                />

                <p className={styles.error}>{errors.voucherCode}</p>
              </div>
              <button className={styles.button} onClick={applyVoucherHandler}>
                Apply
              </button>
            </div>
          ) : (
            <div className={styles.couponSuccessContainer}>
              <p className={styles.heading}>Coupon Applied</p>

              <div className={styles.voucherContainer}>
                <p className={styles.voucherCode}>{voucherCode}</p>

                <p className={styles.voucherDiscount}>
                  ${voucherDiscountAmount}
                </p>
              </div>

              <div className={styles.buttonContainer}>
                <button
                  className={styles.button}
                  onClick={removeVoucherHandler}
                >
                  Remove Voucher
                </button>
              </div>
            </div>
          )}
        </div>
        <div className={styles.headingContainer}>
          <p className={styles.label}>Enter card information</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Card Holder Name</p>
          <input
            className={styles.input}
            type="text"
            value={cardHolderName}
            onChange={(e) => setCardHolderName(e.target.value)}
          />
          <p className={styles.error}>{errors.cardNumber}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Card Number</p>
          <input
            className={styles.input}
            type="text"
            value={cardNumber}
            maxLength={19}
            onChange={(e) => {
              let val = e.target.value.replace(/\D/g, "");
              val = val.match(/.{1,4}/g)?.join(" ") || "";
              setCardNumber(val);
            }}
          />
          <p className={styles.error}>{errors.cardNumber}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Expiration Date</p>
            <input
              className={styles.input}
              type="text"
              value={expiry}
              maxLength={5}
              onChange={(e) => {
                let val = e.target.value;
                val = val.replace(/[^\d\\/]/g, "");
                val = val.replace(/\//g, "");
                if (val.length > 2)
                  val = val.slice(0, 2) + "/" + val.slice(2, 4);
                setExpiry(val);
              }}
            />
            <p className={styles.error}>{errors.expiry}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>CVV</p>
            <input
              className={styles.input}
              type="text"
              value={cvv}
              onChange={(e) => setCvv(e.target.value)}
            />
            <p className={styles.error}>{errors.cvv}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const Step3 = ({
  familyMembers,
  setFamilyMembers,
  packageData,
}: {
  familyMembers: FamilyMember[];
  setFamilyMembers: React.Dispatch<React.SetStateAction<FamilyMember[]>>;
  packageData: any;
}) => {
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  }>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });

  const addMemberHandler = () => {
    if (packageData?.noofMembers < familyMembers.length) {
      toastHelper.error(
        "You have reached the maximum number of family members",
      );
      return;
    }

    const { errors: fieldErrors, isValid } = validator([
      {
        key: "firstName",
        type: "text",
        value: firstName,
      },
      {
        key: "lastName",
        type: "text",
        value: lastName,
      },
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "phoneNumber",
        type: "text",
        value: phoneNumber,
      },
    ]);

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));

    if (isValid) {
      const emailExists = familyMembers.some(
        (member) => member.email === email,
      );
      if (emailExists) {
        setErrors((prev) => ({
          ...prev,
          email: "Email already exists",
        }));
        return;
      }
      setFamilyMembers((prev) => [
        ...prev,
        {
          id: generateUuid(),
          firstName,
          lastName,
          email,
          phoneNumber,
          bookingAllowed: false,
        },
      ]);
      memberClearHandler();
    }
  };

  const deleteMemberHandler = (id: string) => {
    setFamilyMembers((prev) => prev.filter((member) => member.id !== id));
  };

  const memberClearHandler = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setErrors({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    });
  };

  const columnDefs = useMemo<ColDef<FamilyMember>[]>(
    () => [
      {
        headerName: "First Name",
        field: "firstName",
        flex: 1,
      },
      {
        headerName: "Last Name",
        field: "lastName",
        flex: 1,
      },
      {
        headerName: "Email",
        field: "email",
        flex: 1,
      },
      {
        headerName: "Phone",
        field: "phoneNumber",
        flex: 1,
      },
      {
        headerName: "Booking Allowed",
        field: "bookingAllowed",
        flex: 1,
        cellRenderer: (params: ICellRendererParams<FamilyMember>) => (
          <Switch
            inActiveTrackColor="#DFDFDF"
            activeTrackColor="#C0F496"
            inActiveThumbColor="#000000"
            activeThumbColor="#000000"
            checked={params?.data?.bookingAllowed ?? false}
            onChange={(val) => {
              setFamilyMembers((prev) =>
                prev.map((member) =>
                  member.id === params?.data?.id
                    ? {
                        ...member,
                        bookingAllowed: val,
                      }
                    : member,
                ),
              );
            }}
          />
        ),
      },
      {
        sortable: false,
        suppressAutoSize: true,
        suppressMovable: true,
        suppressNavigable: true,
        width: 100,
        editable: false,
        cellStyle: {
          pointerEvents: "all",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        },
        cellRenderer: (params: ICellRendererParams<FamilyMember>) => (
          <div className={styles.iconContainer}>
            <Menu
              direction="left"
              menuButton={
                <MenuButton>
                  <HiDotsVertical className={styles.icon} />
                </MenuButton>
              }
              transition
              portal
            >
              <MenuItem
                onClick={() => deleteMemberHandler(params?.data?.id ?? "")}
              >
                Delete
              </MenuItem>
            </Menu>
          </div>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setFamilyMembers],
  );

  const defaultColDef = useMemo<ColDef<FamilyMember>>(
    () => ({
      resizable: true,
      sortable: true,
      filter: false,
      wrapText: true,
      autoHeight: true,
      unSortIcon: true,
    }),
    [],
  );

  return (
    <div className={styles.stepThreeContainer}>
      <div className={styles.headingContainer}>
        <p className={styles.label}>Add Family Members</p>
      </div>
      <div className={styles.familyMembersContainer}>
        <div className={styles.gridContainer}>
          <AgGridReact
            className={styles.grid}
            rowData={familyMembers}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            getRowId={(params: GetRowIdParams<FamilyMember>) => params.data.id}
            animateRows
            domLayout="autoHeight"
          />
        </div>
        <div className={styles.formContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>First Name</p>
            <input
              className={styles.input}
              type="text"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <p className={styles.error}>{errors.firstName}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Last Name</p>
            <input
              className={styles.input}
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <p className={styles.error}>{errors.lastName}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Email</p>
            <input
              className={styles.input}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <p className={styles.error}>{errors.email}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Phone Number</p>
            <input
              className={styles.input}
              type="text"
              value={phoneNumber}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setPhoneNumber(value);
                }
              }}
            />
            <p className={styles.error}>{errors.phoneNumber}</p>
          </div>
          <div className={styles.buttonsContainer}>
            <button className={styles.button} onClick={addMemberHandler}>
              Add Member
            </button>
            <button className={styles.clearButton} onClick={memberClearHandler}>
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

function NonMemberSignup() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const signRef = useRef<SignatureCanvas>(null);
  const {
    signupLoading,
    getBuildingsByZipCodeLoading,
    getBuildingsByZipCodeData,
  } = useSelector((state: RootState) => state.auth);
  const [voucherCode, setVoucherCode] = useState<string>("");
  const [voucherSuccess, setVoucherSuccess] = useState<any>(null);
  const [zipCode, setZipCode] = useState<string>("");
  const [currentStep, setCurrentStep] = useState<number>(0);
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [selectedPackage, setSelectedPackage] = useState<number>(-1);
  const [selectedBuilding, setSelectedBuilding] = useState<any>(null);
  const [cardHolderName, setCardHolderName] = useState<string>("");
  const [cardNumber, setCardNumber] = useState<string>("");
  const [expiry, setExpiry] = useState<string>("");
  const [cvv, setCvv] = useState<string>("");
  const [signature, setSignature] = useState<string>("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [familyMembers, setFamilyMembers] = useState<FamilyMember[]>([]);
  const [parkingSelections, setParkingSelections] = useState<
    ParkingSelection[]
  >([]);
  const [addonSelections, setAddonSelections] = useState<AddonSelection[]>([]);
  const [additionalAmenitiesModal, setAdditionalAmenitiesModal] =
    useState(false);

  const [additionalAddonsModal, setAdditionalAddonsModal] = useState(false);
  const [errors, setErrors] = useState<{
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    password: string;
    confirmPassword: string;
    cardHolderName: string;
    cardNumber: string;
    expiry: string;
    cvv: string;
    zipCode: string;
    voucherCode: string;
  }>({
    email: "",
    password: "",
    confirmPassword: "",
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvv: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    zipCode: "",
    voucherCode: "",
  });

  const buildingData: any = useMemo(() => {
    if (getBuildingsByZipCodeData && selectedBuilding) {
      return getBuildingsByZipCodeData?.find(
        (building: any) =>
          building?.building?.buildingId ===
            selectedBuilding?.building?.buildingId ||
          building?.building?.buildingId ===
            selectedBuilding?.building?.buildingId,
      );
    }
    return null;
  }, [getBuildingsByZipCodeData, selectedBuilding]);

  const packageData: any = useMemo(() => {
    if (buildingData && selectedPackage) {
      return buildingData?.packages?.find(
        (pack: any) =>
          pack?.packageId === selectedPackage ||
          // eslint-disable-next-line eqeqeq
          pack?.packageId == selectedPackage,
      );
    }
    return null;
  }, [buildingData, selectedPackage]);

  const maxSteps = 5;

  const nextStepHandler = () => {
    let step = currentStep + 1;
    if (step === maxSteps) {
      if (!signupLoading) {
        const successHandler = () => {
          navigate("/login", {
            replace: true,
            state: { signup_success: true },
          });
        };

        if (
          selectedPackage === -1 ||
          selectedPackage === undefined ||
          selectedPackage === null
        ) {
          dispatch(
            nonMemberSignupUserWithoutPackage(
              {
                firstName,
                lastName,
                phoneNumber,
                buildingId: selectedBuilding?.building?.buildingId,
                email,
                password,
                packageId: null,
                content: "signature",
                signature: signature,
                cardNumber: cardNumber.replace(/\s/g, ""),
                cardName: cardHolderName,
                expiry: expiry.replace(/\//g, ""),
                cvv: cvv,
                addons: addonSelections.filter((s) => s.noofAddonUnits > 0),
                slots: parkingSelections.filter((s) => s.noOfVehicle > 0),
                familyMember: packageData?.isFamily ? familyMembers : [],
                voucherCode: voucherSuccess?.voucher?.name,
              },
              successHandler,
            ),
          );
        } else {
          dispatch(
            nonMemberSignupUser(
              {
                firstName,
                lastName,
                phoneNumber,
                buildingId: selectedBuilding?.building?.buildingId,
                email,
                password,
                packageId: selectedPackage,
                content: "signature",
                signature: signature,
                cardNumber: cardNumber.replace(/\s/g, ""),
                cardName: cardHolderName,
                expiry: expiry.replace(/\//g, ""),
                cvv: cvv,
                addons: addonSelections.filter((s) => s.noofAddonUnits > 0),
                slots: parkingSelections.filter((s) => s.noOfVehicle > 0),
                familyMember: packageData?.isFamily ? familyMembers : [],
                voucherCode: voucherSuccess?.voucher?.name,
              },
              successHandler,
            ),
          );
        }
      } else {
        toastHelper.error("Please wait for the signup to complete");
      }
    } else {
      if (currentStep === 1 && packageData?.isFamily) {
        setCurrentStep(step);
        return;
      } else if (currentStep === 1 && !packageData?.isFamily) {
        setCurrentStep(step + 1);
      } else {
        setCurrentStep(step);
      }
    }
  };

  const backStepHandler = () => {
    const step = currentStep - 1;
    if (step >= 0) {
      if (currentStep === 3 && packageData?.isFamily) {
        setCurrentStep(step);
      } else if (currentStep === 3 && !packageData?.isFamily) {
        setCurrentStep(step - 1);
      } else {
        setCurrentStep(step);
      }
    }
  };

  const stepHandler = () => {
    if (currentStep === 0) {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "firstName",
          type: "text",
          value: firstName,
        },
        {
          key: "lastName",
          type: "text",
          value: lastName,
        },
        {
          key: "phoneNumber",
          type: "text",
          value: phoneNumber,
        },
        {
          key: "email",
          type: "email",
          value: email,
        },
        {
          key: "password",
          type: "password",
          value: password,
        },
        {
          key: "confirmPassword",
          type: "confirmPassword",
          value: confirmPassword,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid) {
        nextStepHandler();
      }
    }

    if (currentStep === 1) {
      const noPackageSelected =
        selectedPackage === -1 ||
        selectedPackage === undefined ||
        selectedPackage === null;

      const hasParking = buildingData?.building?.parking?.length > 0;

      const hasParkingSelection = parkingSelections.some(
        (s) => s.noOfVehicle > 0,
      );

      if (noPackageSelected) {
        if (hasParking) {
          if (!hasParkingSelection) {
            toastHelper.error("Please select package or parking amenity");
            return;
          }

          const parkingList = buildingData?.building?.parking ?? [];

          const invalidSelection = parkingSelections.some((selection) => {
            if (selection.notifyParking) return false;

            const parkingConfig = parkingList.find(
              (p: any) => String(p.parkingId) === selection.parkingId,
            );

            if (!parkingConfig) return false;

            return (
              selection.noOfVehicle > (parkingConfig.availableNoofvehicle ?? 0)
            );
          });

          if (invalidSelection) {
            toastHelper.error(
              "Parking amenities are not available, you can select notify to get notified when parking amenities are available",
            );
            return;
          }
        } else {
          toastHelper.error("Please select a package");
          return;
        }
      }

      nextStepHandler();
    }
    if (currentStep === 2) {
      if (familyMembers.length === 0) {
        toastHelper.error("Please add at least one member");
        return;
      }
      nextStepHandler();
    }

    if (currentStep === 3) {
      if (signRef?.current) {
        if (signRef.current.isEmpty()) {
          toastHelper.error("Please sign the agreement");
        } else {
          setSignature(signRef.current.toDataURL());
          nextStepHandler();
        }
      }
    }

    if (currentStep === 4) {
      const { errors: fieldErrors, isValid } = validator([
        {
          key: "cardHolderName",
          type: "text",
          value: cardHolderName,
        },
        {
          key: "cardNumber",
          type: "text",
          value: cardNumber,
        },
        {
          key: "expiry",
          type: "text",
          value: expiry,
        },
        {
          key: "cvv",
          type: "text",
          value: cvv,
        },
      ]);
      setErrors({ ...errors, ...fieldErrors });
      if (isValid) {
        nextStepHandler();
      }
    }
  };

  const Step4 = (props: { content: string }) => {
    const { content } = props;
    const contentRef = useRef<HTMLDivElement>(null);

    const handleDownloadPDF = () => {
      const element = contentRef.current;

      const opt: any = {
        margin: 0.5,
        filename: "Amengies Terms and Conditions.pdf",
        image: { type: "jpeg", quality: 1 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "in",
          format: "letter",
          orientation: "portrait",
        },
      };

      if (element) {
        html2pdf().set(opt).from(element).save();
      }
    };
    return (
      <div className={styles.stepFourContainer}>
        <div className={styles.pdfButtonContainer}>
          <button className={styles.button} onClick={handleDownloadPDF}>
            <FaFilePdf className={styles.icon} />
          </button>
        </div>
        <div
          className={styles.contentContainer}
          dangerouslySetInnerHTML={{
            __html: content,
          }}
          ref={contentRef}
        ></div>
        <div className={styles.signatureContainer}>
          <p className={styles.label}>Sign the agreement</p>
          <div className={styles.signature}>
            <SignatureCanvas
              penColor="black"
              ref={signRef}
              canvasProps={{
                className: `${styles.signatureCanvas}`,
              }}
            />
          </div>
          <div className={styles.buttonContainer}>
            <button
              className={styles.clearButton}
              onClick={() => {
                if (signRef.current) {
                  signRef.current.clear();
                }
              }}
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    );
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <Step1
            firstName={firstName}
            setFirstName={setFirstName}
            lastName={lastName}
            setLastName={setLastName}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            showConfirmPassword={showConfirmPassword}
            setShowConfirmPassword={setShowConfirmPassword}
            errors={errors}
          />
        );
      case 1:
        return (
          <Step2
            setAdditionalAmenitiesModal={setAdditionalAmenitiesModal}
            selectedBuilding={selectedBuilding}
            setSelectedBuilding={setSelectedBuilding}
            zipCode={zipCode}
            setZipCode={setZipCode}
            selectedPackage={selectedPackage}
            setSelectedPackage={setSelectedPackage}
            setAdditionalAddonsModal={setAdditionalAddonsModal}
            errors={errors}
          />
        );
      case 2:
        return (
          <Step3
            familyMembers={familyMembers}
            setFamilyMembers={setFamilyMembers}
            packageData={packageData}
          />
        );
      case 3:
        return (
          <Step4
            content={
              selectedPackage === -1 ||
              selectedPackage === undefined ||
              selectedPackage === null
                ? selectedBuilding?.building?.parking?.[0]?.terms
                : selectedBuilding?.building?.termsAndConditions
            }
          />
        );
      case 4:
        return (
          <Step5
            selectedBuilding={selectedBuilding}
            parkingSelections={parkingSelections}
            addonSelections={addonSelections}
            email={email}
            voucherCode={voucherCode}
            setVoucherCode={setVoucherCode}
            voucherSuccess={voucherSuccess}
            setVoucherSuccess={setVoucherSuccess}
            packageData={packageData}
            cardHolderName={cardHolderName}
            setCardHolderName={setCardHolderName}
            cardNumber={cardNumber}
            setCardNumber={setCardNumber}
            expiry={expiry}
            setExpiry={setExpiry}
            cvv={cvv}
            setCvv={setCvv}
            errors={errors}
            setErrors={setErrors}
          />
        );
      default:
        return <></>;
    }
  };

  useEffect(() => {
    const { email, password, confirmPassword } =
      location.state ??
      ({} as any as {
        email: string;
        password: string;
        confirmPassword: string;
      });
    if (email && password && confirmPassword) {
      setEmail(email);
      setPassword(password);
      setConfirmPassword(confirmPassword);
    }
  }, [location]);

  useEffect(() => {
    return () => {
      dispatch(clearNonMemberData());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Header />
      <MobileHeader />
      <AdditionalAmenitiesModal
        isOpen={additionalAmenitiesModal}
        setIsOpen={setAdditionalAmenitiesModal}
        parkingSelections={parkingSelections}
        setParkingSelections={setParkingSelections}
        parkingOptions={selectedBuilding?.building?.parking || []}
      />
      <AdditionalAddonsModal
        isOpen={additionalAddonsModal}
        setIsOpen={setAdditionalAddonsModal}
        addonSelections={addonSelections}
        setAddonSelections={setAddonSelections}
        addonOptions={selectedBuilding?.building?.addon || []}
      />
      <div className={styles.mainContainer}>
        <div className={styles.stepContainer}>
          <Stepper
            showLabel={true}
            currentStep={currentStep}
            steps={Array.from({ length: maxSteps }, (_, index) => ({
              id: index + 1,
              label: `Step ${index + 1}`,
            }))}
          />
        </div>
        <div className={styles.bodyContainer}>{renderCurrentStep()}</div>
        {getBuildingsByZipCodeLoading && <Loading />}
        {signupLoading && <Loading />}
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={stepHandler}>
            Next
          </button>
        </div>

        {currentStep !== 0 && (
          <div className={styles.buttonContainer}>
            <button className={styles.back} onClick={backStepHandler}>
              Back
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default NonMemberSignup;
